import { endpoint } from "@services/api.services";
import { METHODS } from "@services/interface.service";
import { GeneralCard, TableCard } from "@ui/internal/components/card";
import FilterPopover from "@ui/internal/components/filter-popover";
import { formatDate } from "@utils/helper/index.helper";
import { usePathname } from "@utils/hook/index.hook";
import { QueryData } from "@utils/interface/index.interface";
import { useListData, usePostData } from "@utils/query/index.query";
import { useMetaStore } from "@utils/states/index.state";
import React, { useEffect } from "react";
import { useSearchParams } from "react-router";
import { ColumnList } from "./columns";
import CareerForm from "../careers/form/index.form";
import { PopupForm } from "./forms";

type Props = {};

const index: React.FC<Props> = ({}) => {
  const pathname = usePathname();
  console.log("Pathname", pathname);
  const { search, date } = useMetaStore();
  const [searchParams, setSearchParams] = useSearchParams();
  let {
    data: fetchData,
    refetch,
    isPending,
    error,
  } = useListData<QueryData<any>>({
    endpoint: endpoint["popup"],
    key: `${pathname}-listing`,
    params: {
      page: searchParams.get("tpage") || 1,
      size: searchParams.get("per") || 10,
      search,
      is_show: searchParams.get("is_show") || "",
      created_date__gte: date.from ? formatDate(date.from) : "",
      created_date__lte: date.to ? formatDate(date.to) : "",
      ordering: searchParams.get("ordering") || "order",
    },
  });
  useEffect(() => {
    if (error?.status === 404 && error?.data?.detail === "Invalid page.") {
      searchParams.set("tpage", "1");
      setSearchParams(searchParams);
    }
  }, [error]);
  const { mutate } = usePostData();
  const toggleActiveStatus = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["popup"],
        data: {
          is_show: state,
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          if (fetchData) {
            const newItems = fetchData.data.results.map((item) =>
              item.id === id ? { ...item, is_show: state } : item
            );

            fetchData.data.results = newItems;
          }
        },
        onError: (data) => {
          console.log(data);
        },
      }
    );
  };
  const toggleSkippable = (id: string | number, state: boolean) => {
    mutate(
      {
        endpoint: endpoint["popup"],
        data: {
          is_skipable: state,
          id,
        },
        method: METHODS.PATCH,
      },
      {
        onSuccess: () => {
          if (fetchData) {
            const newItems = fetchData.data.results.map((item) =>
              item.id === id ? { ...item, is_skipable: state } : item
            );

            fetchData.data.results = newItems;
          }
        },
        onError: (data) => {
          console.log(data);
        },
      }
    );
  };
  const columns = ColumnList({ refetch, toggleActiveStatus, toggleSkippable });

  return (
    <>
      <TableCard
        bulkActions
        showOrientationSecond
        rows={fetchData?.data?.results ?? []}
        isPending={isPending}
        endpoint={endpoint["popup"]}
        count={fetchData?.data?.count ?? 10}
        refetch={refetch}
        table_content={{
          mode: "default",
          type: pathname,
        }}
        grid={
          <GeneralCard
            isChecked={false}
            showCheck
            type={"success-stories"}
            onDelete={() => {}}
            onEdit={() => {}}
          />
        }
        columns={columns}
        inject_ui_table_actions={<></>}
        formId={pathname}
        form={<PopupForm />}
        sortableFilter={{
          search: search,
        }}
      />
    </>
  );
};

export default index;
